import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { EmptyStateContentSuggestionViewModel } from '../viewModels/EmptyStateContentSuggestionViewModel';
import { renderContentSuggestionItems } from './ContentSuggestion';

export function EmptyStateContentSuggestion(props: { viewModel: EmptyStateContentSuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return renderContentSuggestionItems(viewModel);
}
